import React from "react";
import { Form, Table } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { commonservices } from "../services/CommonServices";
import deprecateIcon from "../assets/images/Depricate.svg";
import updateIcon from "../assets/images/Upgrade.svg";
import discontinueIcon from "../assets/images/Discontinue.svg";

const MachineVersionModal = (props) => {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="normal-modal log-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Machine Version
        </Modal.Title>
      </Modal.Header>
      <Form>
        <Modal.Body>
          <div className="table-wrapper-main schedular-page-table-height">
            <Table responsive>
              <thead>
                <tr>
                  <th className="width200">Machine Name</th>
                  <th className="width200">Last Update On</th>
                  <th className="width200">Version</th>
                  <th className="text-end">Action</th>
                  {/* <th>Status</th> */}
                </tr>
              </thead>
              <tbody>
                {props?.machineversionlist?.length > 0 ? (
                  props?.machineversionlist?.map((item, index) => (
                    <tr key={index}>
                      <td>{item?.machinename}</td>
                      <td>
                        {item?.lastupdatedon
                          ? commonservices.getDateInFormatCustom(
                              item?.lastupdatedon,
                              null,
                              "MMMM d,yyyy"
                            )
                          : " - "}
                      </td>
                      <td>{item?.versionnumber}</td>
                      <td className="">
                        <div className="all-actions">
                          <img
                            title="update"
                            src={updateIcon}
                            alt="updateAction"
                          />
                          <img
                            title="deprecate"
                            src={deprecateIcon}
                            alt="depricateAction"
                          />

                          <img
                            title="discontinue"
                            src={discontinueIcon}
                            alt="discontinueAction"
                          />
                        </div>
                      </td>
                      {/* <td>
                            {item?.status === "Publish" ? (
                              <div className="status-active">
                                <img src={activestatus} alt="activestatus" />
                                <span className="fw600 green-color-text">
                                  {item?.status}
                                </span>
                              </div>
                            ) : (
                              <div className="status-active">
                                <img src={inactivestatus} alt="activestatus" />
                                <span className="fw600 red-color-text">
                                  {item?.status}
                                </span>
                              </div>
                            )}
                          </td> */}
                    </tr>
                  ))
                ) : (
                  <tr className="text-center">
                    <td colSpan={4}>no data found.</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Modal.Body>
      </Form>
    </Modal>
  );
};

export default MachineVersionModal;
